export function Checkbox({ className = '', children, ...rest }: React.PropsWithChildren<React.InputHTMLAttributes<HTMLInputElement>>) {
    return (
        <div className={'size-[20px] min-w-[20px] rounded-[4px] bg-dark-slate-gray border border-deep-navy ' + className}>
            <input type='checkbox' className='h-full w-full appearence-none opacity-0 checked:opacity-100 accent-dark-slate-gray' {...rest} />
        </div>
    );
}
